import BaseViewController from "../base-view-controller";
import { APP_DATA_VALUE_KEYS } from "../../utils/constants";
import { removeCachedKeys } from "../../utils/app-data-utils";

class SetHighBloodSugarThresholdViewController extends BaseViewController {
  preprocessScreenData() {
    super.preprocessScreenData();
    this.cleanUpHistory();

    const { fields } = this.screen;
    const thresholdSliderLabel = document.getElementById(
      "threshold_slider_high-label"
    );
    const thresholdSliderInput = document.getElementById(
      "threshold_slider_high-input"
    );
    const saveButton = fields.find(f => f.name === "save_button");
    const webWarningMessage = fields.find(
      f => f.name === "web_warning_message"
    );

    const thresholdSliderHighValue = Number(
      this.appData.values.threshold_slider_high
    );
    const MinThreshold = Number(this.appData.values.min_threshold);
    const MaxThreshold = Number(this.appData.values.max_threshold);
    webWarningMessage.type = "hidden";
    saveButton.disabled = true;
    if (
      thresholdSliderLabel !== null &&
      this.appData.values.threshold_slider_high === ""
    ) {
      thresholdSliderLabel.classList.remove("label_title_warning");
      thresholdSliderInput.classList.remove("input_field_warning");
      thresholdSliderLabel.classList.add("label_title_passed");
      thresholdSliderInput.classList.add("input_field_passed");
      webWarningMessage.type = "hidden";
      saveButton.disabled = true;
    } else if (
      (MinThreshold > thresholdSliderHighValue ||
        thresholdSliderHighValue > MaxThreshold ||
        Number.isNaN(thresholdSliderHighValue)) &&
      thresholdSliderLabel !== null
    ) {
      thresholdSliderLabel.classList.remove("label_title_passed");
      thresholdSliderInput.classList.remove("input_field_passed");
      thresholdSliderLabel.classList.add("label_title_warning");
      thresholdSliderInput.classList.add("input_field_warning");
      webWarningMessage.type = "text";
      saveButton.disabled = true;
    } else if (thresholdSliderLabel !== null) {
      thresholdSliderLabel.classList.remove("label_title_warning");
      thresholdSliderInput.classList.remove("input_field_warning");
      thresholdSliderLabel.classList.add("label_title_passed");
      thresholdSliderInput.classList.add("input_field_passed");
      webWarningMessage.type = "hidden";
      saveButton.disabled = false;
    } else {
      webWarningMessage.type = "hidden";
      saveButton.disabled = false;
    }
  }

  cleanUpHistory() {
    const allowedValueKeys = [
      APP_DATA_VALUE_KEYS.loggedInMemberId,
      APP_DATA_VALUE_KEYS.minThreshold,
      APP_DATA_VALUE_KEYS.maxThreshold,
      APP_DATA_VALUE_KEYS.thresholdSliderHigh
    ];

    removeCachedKeys(this.appData.values, allowedValueKeys);
  }
}

export default SetHighBloodSugarThresholdViewController;
